export function getInitials(name?: string): string {
  if (!name?.trim()) {
    return '';
  }
  const namesArray = name.trim().split(' ');
  const firstName = namesArray[0];
  const lastName = namesArray[namesArray.length - 1];
  const firstInitial = firstName.charAt(0);
  const lastInitial = lastName.charAt(0);
  return `${firstInitial}${lastInitial}`.toUpperCase();
}
